<template>
    <div>
        <button @click="goBack" type="button" class="btn btn-lg btn-link">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
            Back
        </button>

        <div style="min-width: 400px; width: 40vw; margin: auto; margin-top: 100px;" class="border-box">
            <div>
                <h3 class="fg-color-blue">Change your password</h3>
                <br />
                <div v-if="errorChangePasswordCommandV1" class="alert alert-danger">
                    {{ errorChangePasswordCommandV1 }}
                </div>

                <div class="form-group">
                    <label for="Password">New password:</label>
                    <input v-model="password" type="password" class="form-control">
                    <ValidationError context="Password" :errors="validationErrors"></ValidationError>
                </div>

                <div class="form-group" v-show="password">
                    <label for="PasswordConfirmation">New password confirmation:</label>
                    <input v-model="passwordConfirmation" type="password" class="form-control">
                </div>
                <br />

                <button @click="handleChangePasswordCommandV1" type="button" class="btn btn-primary btn-lg btn-block" :disabled="!isValid">Change password</button>
            </div>

            <div v-if="passwordPolicy" style="margin-top: 25px; font-size: 16px;">
                <strong>Password validation requirements:</strong>
                <ul style="margin-top: 8px;">
                    <li v-for="rule in passwordPolicy.Rules">{{rule}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, computed, onMounted, watch } from 'vue'
    import { useRouter } from 'vue-router'

    import ValidationError from '@common/Components/ValidationError.vue'
    import { useCurrentUserQueryV1, usePasswordPolicyQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import { useChangePasswordCommandV1 } from '@Organizations/Users/commands-vue-composables'

    const router = useRouter()

    const password = ref('')
    const passwordConfirmation = ref('')

    const { runCurrentUserQueryV1,
        modelCurrentUserQueryV1: userSessionDetails } = useCurrentUserQueryV1()

    const { runPasswordPolicyQueryV1,
        modelPasswordPolicyQueryV1: passwordPolicy } = usePasswordPolicyQueryV1()

    const userId = computed(() => userSessionDetails.value?.UserId)

    const passwordConfirmed = computed(() => password.value === passwordConfirmation.value)
    const isValid = computed(() =>!!password.value && passwordConfirmed.value)

    const {
        invokeChangePasswordCommandV1,
        validationErrors,
        errorChangePasswordCommandV1,
        succeedChangePasswordCommandV1
    } = useChangePasswordCommandV1(userId, password)

    watch(succeedChangePasswordCommandV1, (succeeded) =>
    {
        if (succeeded)
        {
            router.push('/')
        }
    })

    onMounted(() =>
    {
        document.title = 'Change password'
        runCurrentUserQueryV1();
        runPasswordPolicyQueryV1()
    })

    function handleChangePasswordCommandV1()
    {
        if (!isValid.value || !userId.value) return

        if (errorChangePasswordCommandV1.value)
        {
            errorChangePasswordCommandV1.value = null
        }

        invokeChangePasswordCommandV1()
    }

    function goBack()
    {
        router.back()
    }
</script>
